import { useTranslation } from 'react-i18next'

import { useUser } from '@/contexts/user/User.context'

import Button from '../ui/Button/Button'

import './Tier0WaitingPage.scss'

const Tier0WaitingPage = () => {
  const { t } = useTranslation()

  const { user } = useUser()
  const { id, username, email, phoneNumber } = user || {}

  return (
    <div className="loading-page">
      <svg fill="none" height="120" viewBox="0 0 120 120" width="120" xmlns="http://www.w3.org/2000/svg">
        <path
          clipRule="evenodd"
          d="M99.2675 45.47H84.4475C75.6175 45.425 68.3275 38.11 68.3275 29.19V13.49C68.3275 12.275 67.3626 11.25 66.1076 11.25H40.3325C28.3125 11.25 18.5625 21.145 18.5625 33.235V85.79C18.5625 98.465 28.7975 108.75 41.3475 108.75H79.7175C91.7375 108.75 101.438 98.95 101.438 86.86V47.665C101.438 46.445 100.473 45.47 99.2675 45.47Z"
          fill="black"
          fillRule="evenodd"
          opacity="0.4"
        />
        <path
          clipRule="evenodd"
          d="M85.079 38.3587C88.444 38.3937 93.119 38.4087 97.084 38.3937C99.114 38.3887 100.144 35.9387 98.739 34.4587C96.194 31.7887 92.649 28.0637 89.089 24.3237C85.514 20.5687 81.924 16.7987 79.314 14.0587C77.869 12.5437 75.349 13.5837 75.349 15.6837V28.5287C75.349 33.9187 79.744 38.3587 85.079 38.3587Z"
          fill="black"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M57.395 84.2869L72.61 67.6969C75.82 64.2119 75.605 58.7669 72.13 55.5619L68.885 52.5469C67.195 50.9869 64.97 50.1719 62.715 50.2719C60.42 50.3619 58.295 51.3419 56.73 53.0369L41.3101 69.8619C39.6051 71.7719 38.5551 74.1319 38.2801 76.6819L37.8851 80.3269C37.6251 82.7419 38.4901 85.0869 40.2551 86.7569C41.7051 88.1219 43.5701 88.8569 45.5201 88.8569C45.9501 88.8569 46.3851 88.8219 46.8201 88.7469L50.34 88.1569C53.06 87.7069 55.58 86.3219 57.395 84.2869ZM63.0515 57.7634C63.2565 57.7634 63.5365 57.8184 63.7865 58.0484L67.0315 61.0684C67.4765 61.4734 67.5015 62.1684 67.0865 62.6234L51.8315 79.2534C51.1215 80.0534 50.1465 80.5884 49.1014 80.7584L45.3464 81.1384L45.7414 77.4934C45.8414 76.5034 46.2464 75.5884 46.8714 74.8884L62.2515 58.1134C62.5015 57.8384 62.8015 57.7734 63.0065 57.7634H63.0515Z"
          fill="black"
          fillRule="evenodd"
        />
      </svg>

      <h1>{t('tier0WaitingPageTitle', { username })}</h1>
      <p>{t('tier0WaitingPageSubTitle')}</p>
      <Button
        className="primary"
        href={t('tier0WaitingPageButtonLink', { id: id?.split('|')[1], username, email, phoneNumber })}
        target="_blank"
      >
        {t('tier0WaitingPageButtonContent')}
      </Button>
    </div>
  )
}

export default Tier0WaitingPage
